import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseService } from './base.service';
import {
  CreateSubAccountDto,
  DetachSubAccountDto,
  User,
  PaginationParams,
  UpdateUserDto,
} from '../interfaces/user.interface';

@Injectable({
  providedIn: 'root',
})
export class UserService extends BaseService {
  constructor(http: HttpClient) {
    super(http);
  }

  // Créer un sous-compte
  createSubAccount(subAccountData: CreateSubAccountDto): Observable<any> {
    return this.http.post(
      `${this.baseUrl}/users/sub-accounts`,
      subAccountData,
      { headers: this.getAuthHeaders() }
    );
  }

  // Obtenir tous les sous-comptes
  getSubAccounts(): Observable<any> {
    return this.http.get(`${this.baseUrl}/users/sub-accounts`, {
      headers: this.getAuthHeaders(),
    });
  }

  // Détacher un sous-compte
  detachSubAccount(detachData: DetachSubAccountDto): Observable<any> {
    return this.http.post(
      `${this.baseUrl}/users/sub-accounts/detach`,
      detachData,
      { headers: this.getAuthHeaders() }
    );
  }

  // Obtenir la liste paginée des utilisateurs
  getUsers(params: PaginationParams = {}): Observable<any> {
    const httpParams = this.createParams(params);
    return this.http.get(`${this.baseUrl}/users`, {
      headers: this.getAuthHeaders(),
      params: httpParams,
    });
  }

  // Mettre à jour les informations d'un utilisateur
  updateUser(
    userId: string,
    updateData: UpdateUserDto
  ): Observable<{ message: string; user: User }> {
    return this.http.patch<{ message: string; user: User }>(
      `${this.baseUrl}/users/${userId}`,
      updateData,
      { headers: this.getAuthHeaders() }
    );
  }
}
